import React from 'react';
/*
const GradientSeparator = () => {
  return (
    <div className="flex h-2">
      <div className="w-1/4 bg-gradient-to-r from-custom-yellow to-white"></div>
      <div className="w-1/4 bg-gradient-to-r from-white to-black"></div>
      <div className="w-1/4 bg-gradient-to-r from-black to-white"></div>
      <div className="w-1/4 bg-gradient-to-r from-white to-custom-yellow"></div>
    </div>
  );
};*/

const GradientSeparator = () => {
  return (
     <div
      className="h-2 w-full"
      style={{
        background: `
          linear-gradient(
            to right,
            #fcbb1e 0%,
            white 25%,
            black 50%,
            white 75%,
            #fcbb1e 100%
          )
        `
      }}
    ></div>
  );
};

export default GradientSeparator;